/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * device-mockup-tool-server
 * OpenAPI spec version: 1.10.0
 */
import type {ConverterJobStatusResponse, ConverterVerifyRequest, ConverterVerifyResponse} from '../../model'

import {customFetch} from '../../../mutator/customFetch'

/**
 * Polled by the video-to-gif tool's FE for real conversion progress + the eventual download URL.
 */
export type getJobResponse200 = {
  data: ConverterJobStatusResponse
  status: 200
}

export type getJobResponseSuccess = getJobResponse200 & {
  headers: Headers
}
export type getJobResponse = getJobResponseSuccess

export const getGetJobUrl = (jobId: string) => {
  return `/converter/jobs/${jobId}`
}

export const getJob = async (jobId: string, options?: RequestInit): Promise<getJobResponse> => {
  return customFetch<getJobResponse>(getGetJobUrl(jobId), {
    ...options,
    method: 'GET',
  })
}

/**
 * Captcha pre-flight for the anonymous video-to-gif tool. Verifies reCAPTCHA v3
(invisible, same site key as the contact form). On success issues a
short-lived ticket required by the separate (plain Express, not TSOA)
`POST /converter/video-to-gif` upload endpoint — decoupled so a captcha
retry never requires re-uploading the video.
 */
export type verifyResponse200 = {
  data: ConverterVerifyResponse
  status: 200
}

export type verifyResponseSuccess = verifyResponse200 & {
  headers: Headers
}
export type verifyResponse = verifyResponseSuccess

export const getVerifyUrl = () => {
  return `/converter/verify`
}

export const verify = async (
  converterVerifyRequest: ConverterVerifyRequest,
  options?: RequestInit,
): Promise<verifyResponse> => {
  return customFetch<verifyResponse>(getVerifyUrl(), {
    ...options,
    method: 'POST',
    headers: {'Content-Type': 'application/json', ...options?.headers},
    body: JSON.stringify(converterVerifyRequest),
  })
}
